var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-alt-solid 1",
    clipPath: "url(#clip0_1621_10974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.375 5.75H8.8125V4.0625C8.8125 2.09844 7.21406 0.5 5.25 0.5C3.28594 0.5 1.6875 2.09844 1.6875 4.0625V5.75H1.125C0.503906 5.75 0 6.25391 0 6.875V11.375C0 11.9961 0.503906 12.5 1.125 12.5H9.375C9.99609 12.5 10.5 11.9961 10.5 11.375V6.875C10.5 6.25391 9.99609 5.75 9.375 5.75ZM6.1875 9.6875C6.1875 10.2055 5.76797 10.625 5.25 10.625C4.73203 10.625 4.3125 10.2055 4.3125 9.6875V8.5625C4.3125 8.04453 4.73203 7.625 5.25 7.625C5.76797 7.625 6.1875 8.04453 6.1875 8.5625V9.6875ZM6.9375 5.75H3.5625V4.0625C3.5625 3.13203 4.31953 2.375 5.25 2.375C6.18047 2.375 6.9375 3.13203 6.9375 4.0625V5.75Z",
    fill: "#2948A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1621_10974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.e2af64a77de6ac26c69b9e4012753cbb.svg";
export { ForwardRef as ReactComponent };